import * as z from 'zod';

// Types
import { MediaZod } from '@/types/MediaType';
import { TextZod } from '@/components/molecules/Text/TextType';
import { WaveWrapperZod } from '@/types/WaveWrapperType';

const DualImageTextSectionZod = z.object({
  __component: z.literal('block.deux-images-texte-centrale'),
  id: z.number(),
  leftImage: MediaZod,
  rightImage: MediaZod,
  text: TextZod,
  waveWrapper: WaveWrapperZod.nullable(),
});

export { DualImageTextSectionZod };
export type DualImageTextSectionType = z.infer<typeof DualImageTextSectionZod>;
